import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import { RtlLayer } from "@app/core/theme/RtlLayer";
import { InitialDataFetch } from "@app/features/initial-data-fetch/InitialDataFetch";
import { loadCredentials } from "@app/shared/state/credential-items.atom";

export function RootLayout() {
    const navigate = useNavigate();
    const [isRedirecting, setIsRedirecting] = useState(true);

    useEffect(() => {
      try {
        const credentials = loadCredentials();

        if (credentials.tID) {
          const params = new URLSearchParams();
          if (credentials.uID) params.set('uID', credentials.uID);
          if (credentials.gID) params.set('gID', credentials.gID);
          navigate(`/tour/${credentials.tID}?${params.toString()}`, { replace: true });
        } else if (credentials.uID) {
          const gidParam = credentials.gID ? `?gID=${credentials.gID}` : '';
          navigate(`/mytours/${credentials.uID}${gidParam}`, { replace: true });
        } else {
          navigate('/mytours', { replace: true });
        }
      } catch (e) {
        console.warn('[RootLayout] Failed to read credentials:', e);
        navigate('/mytours', { replace: true });
      }
    }, [navigate]);

    // Show loading spinner while redirecting to prevent white screen
    if (isRedirecting) {
      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            backgroundColor: '#F8FAFC',
          }}
        >
          <CircularProgress sx={{ color: '#E65100' }} />
        </Box>
      );
    }

    return (
      <div className="fragment">
        <InitialDataFetch />

        <RtlLayer>
          <Box className="h-screen flex flex-col bg-slate-100">
            <Box className="flex-1 overflow-auto">
              <Outlet />
            </Box>
          </Box>
        </RtlLayer>
      </div>
    );
  }
